module.exports = __webpack_public_path__ + "static/media/bhodi.efea2b05.png";